export default "__VITE_ASSET__BRe8n53h__"